import type { ThemeOptions } from '@mui/material';

import { typography } from './typography';

export const formComponents = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        ...typography.inputHelperText,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        ...typography.inputLabel,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        ...typography.menuItem,
      },
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>;
